import React, { useRef, useEffect, useState, useContext } from "react";
import "./App.css";
import SideNav from "./components/SideNav";
import LoginModal from "./components/LoginModal";
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import Commercial from "./pages/Commercial";
import Investment from "./pages/Investment";
import Residential from "./pages/Residential";
import PropertyListing from "./pages/PropertyListing";
import About from "./pages/About";
import Agents from "./pages/Agents";
import Links from "./pages/Links";
import Contact from "./pages/Contact";
import { AuthContext } from "./context/AuthContext";

const ScrollingApp = () => {
  const scrollContainerRef = useRef(null);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const handleScroll = (event) => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollLeft += event.deltaY;
      }
    };

    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("wheel", handleScroll, { passive: false });
    }

    return () => {
      if (container) {
        container.removeEventListener("wheel", handleScroll);
      }
    };
  }, []);

  // Show dashboard if user is logged in
  if (user && window.location.pathname === '/dashboard') {
    return <Dashboard />;
  }

  return (
    <div className="h-screen overflow-hidden">
      <SideNav 
        scrollContainerRef={scrollContainerRef} 
        onLoginClick={() => setIsLoginModalOpen(true)}
      />
      <LoginModal 
        isOpen={isLoginModalOpen} 
        onClose={() => setIsLoginModalOpen(false)}
        onLoginSuccess={() => { window.location.href = '/dashboard'; }}
      />
      <div 
        ref={scrollContainerRef}
        className="flex overflow-x-auto overflow-y-hidden snap-x snap-mandatory h-full w-full scrollbar-hide"
        style={{ scrollBehavior: 'smooth', scrollSnapType: 'x mandatory', WebkitOverflowScrolling: 'touch' }}
      >
        <div id="home" className="w-full min-w-full flex-shrink-0 h-full snap-start"><Home /></div>
        <div id="commercial" className="w-full min-w-full flex-shrink-0 h-full snap-start"><Commercial /></div>
        <div id="investment" className="w-full min-w-full flex-shrink-0 h-full snap-start"><Investment /></div>
        <div id="residential" className="w-full min-w-full flex-shrink-0 h-full snap-start"><Residential /></div>
        <div id="listing" className="w-full min-w-full flex-shrink-0 h-full snap-start"><PropertyListing /></div>
        <div id="about" className="w-full min-w-full flex-shrink-0 h-full snap-start"><About /></div>
        <div id="agents" className="w-full min-w-full flex-shrink-0 h-full snap-start"><Agents /></div>
        <div id="links" className="w-full min-w-full flex-shrink-0 h-full snap-start"><Links /></div>
        <div id="contact" className="w-full min-w-full flex-shrink-0 h-full snap-start"><Contact /></div>
      </div>
    </div>
  );
};

export default ScrollingApp;
